import router from './router'
import { store } from './store/index'
import { AppRouteRecordRaw } from './common/types/appRoute.type'
import { PermissionActionContants } from './store/modules/permission'
import { clearAll, getToken } from './utils/storage'
import { UserActionContants } from './store/modules/user'

const whiteList = ['/login','/register','/matchFullScreen','/matchJudgeScreen']

router.beforeEach(async (to, from, next) => {
  const toMetaTitle = to.meta?.title || ''
  document.title = `${toMetaTitle ? (toMetaTitle) : ''}`
  console.log(to,from)
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else if (!store.state.permission.isReqPerm) {
      store.dispatch(UserActionContants.GET_USER_INFO, true)
      const menuPerms = await store.dispatch(UserActionContants.GET_USER_MENU_PERM)

      if(menuPerms.length == 0){
        clearAll()
        next({ path: '/login' })
        return false
      }

      if(menuPerms[0].id == null){
        clearAll()
        next({ path: '/login' })
        return false
      }
      const accessRoutes: Array<AppRouteRecordRaw> = await store.dispatch(PermissionActionContants.GENRATERROUTES, menuPerms)
      accessRoutes.forEach(route => router.addRoute(route))
      next({ ...to, replace: true })
    } else next()
  } else if (whiteList.indexOf(to.path) !== -1) next()
  else {
    next(`/login`)
  }
})
